import { useQuery } from '@tanstack/react-query';
import axios from '../../../utils/axios';
import { USER_TITLE_LABELS } from '../../../constants';
import { useIntl } from 'react-intl';

export const useUser = username => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  return useQuery({
    enabled: !!username,
    queryKey: ['user', username],
    queryFn: async () => {
      let result = await axios.get(`/users/${encodeURIComponent(username)}`);
      if (result.status === 200) {
        // default some values in case they dont exist on object
        if (!result.data.record.useMfa) result.data.record.useMfa = false;
        if (!result.data.record.companyAdmin) result.data.record.companyAdmin = false;
        if (!result.data.record.companyTitle) result.data.record.companyTitle = 'Property Manager';

        // temp setup for user.companytitle to
        // interact with react-select nicely - gets put
        // back to string value on save
        result.data.record.companyTitle = {
          label: USER_TITLE_LABELS[result.data.record.companyTitle] || result.data.record.companyTitle,
          value: result.data.record.companyTitle
        };

        // temp setup for user.status to
        // interact with react-select nicely - gets put
        // back to string value on save
        result.data.record.status = {
          label: result.data.record.status === 'active' ? t('ui.active') : t('ui.disabled'),
          value: result.data.record.status
        };

        return result.data.record;
      }
    },
    refetchOnWindowFocus: false
  });
};
